module.exports = __webpack_public_path__ + "img/food_11.41e8dc5f.jpg";